/**
 * Le logo du Manoir — DÉCLARÉ UNE SEULE FOIS.
 *
 * ⚑ POURQUOI CE FICHIER EXISTE (15/09/2026). Le logo vivait à TROIS endroits,
 * de trois façons, et aucune ne savait que les autres existaient :
 *
 *     components/ui/ManoirBlason.jsx:44   const, la rendition 460
 *     pages/site/SiteHome.jsx:30          SA PROPRE const, le même littéral
 *     components/site/SiteHeader.jsx:104  un littéral EN LIGNE — et pas le
 *                                         même fichier : l'ORIGINAL de 222 Ko
 *
 * Le commentaire de `ManoirBlason` affirmait « `SiteHome` le réexporte pour
 * que rien ne se recopie ». C'était faux : `SiteHome` en tenait une copie.
 *
 * ⚠ Et la troisième adresse coûtait de l'argent à chaque visite. L'audit du
 * 10/09 avait mesuré que l'original pèse **222 433 octets** pour une boîte de
 * 230 px, et fabriqué la rendition qui dit la même silhouette en **14 525**.
 * Le remède fut câblé dans `SiteHome`… et pas dans l'en-tête, qui est sur
 * TOUTES les pages et affiche le logo dans **73 px de large**. Soit
 * **207 908 octets** payés par page pour une boîte grande comme un timbre.
 *
 * *Une règle appliquée à deux branches sur trois ressemble à une règle
 * appliquée.* C'est le même défaut que les vignettes du 14/09, et que le lint
 * qui ne lisait qu'un dossier : ce qui n'est pas dans la liste n'est vérifié
 * par personne.
 *
 * ⚑ LES DIMENSIONS SONT DÉCLARÉES, pour que le rapport ne s'écrive jamais à
 * la main. Une boîte CSS dont la hauteur est tapée au jugé se déforme le jour
 * où le tracé change — exactement ce qui allait arriver le 15/09, les deux
 * lockups n'ayant pas le même rapport (1,35 contre 1,61). `boite()` le
 * calcule depuis les pixels du fichier.
 */

/**
 * Le lockup HISTORIQUE : blason, ornements, filet, puis « LE MANOIR » en
 * CAPITALES sur deux lignes avec « D'AUTUN » entre deux filets courts.
 * Référence : `public/manoir/logo-officiel.jpg`.
 */
export const LOGO_MAISON = Object.freeze({
    src: '/manoir/logo-officiel-mask-460.png',
    largeur: 460,
    hauteur: 340,
});

/**
 * Le lockup que Steven a envoyé le 15/09/2026 : même blason, mêmes
 * ornements, même filet pointillé, mais le nom en BAS-DE-CASSE sur UNE seule
 * ligne — « Le Manoir d'Autun ».
 *
 * ⚠ CE QU'IL NE CONTIENT PAS, et c'est voulu (choix de Steven, en QCM) :
 * « RÉSIDENCE HÔTELIÈRE » et « Chaque suite est une porte sur Autun »
 * figurent sur la carte qu'il a envoyée, mais restent du TEXTE dans les
 * pages — un texte se traduit en sept langues, se lit au lecteur d'écran et
 * reste net à toute taille ; dans une image, il ne fait aucun des trois.
 *
 * ⚠ ET SA DÉFINITION EST CELLE DE LA SOURCE, pas davantage. La carte reçue
 * est une capture : le logo y tient dans 311 × 193 pixels, là où le lockup
 * historique en a 1600 de large. `detourer_logo.py` refuse d'agrandir — une
 * netteté inventée serait l'équivalent visuel d'une invention. Le jour où le
 * fichier du graphiste arrive, on relance l'outil et SEULES ces trois lignes
 * changent.
 */
export const LOGO_2026 = Object.freeze({
    src: '/manoir/logo-officiel-2026-mask-311.png',
    largeur: 311,
    hauteur: 193,
});

/**
 * La boîte CSS d'un logo pour une largeur donnée : la hauteur se DÉDUIT du
 * fichier. Rend `{ width, height }` en pixels entiers.
 */
export function boite(logo, largeurCss) {
    return {
        width: largeurCss,
        height: Math.round((largeurCss * logo.hauteur) / logo.largeur),
    };
}

/**
 * Le style `mask-image` commun aux deux logos — peint par `bg-*`, jamais par
 * le fichier. Écrit ici pour que les quatre emplois cessent de recopier les
 * huit mêmes propriétés préfixées.
 */
export function styleDuMasque(logo) {
    return {
        WebkitMaskImage: `url(${logo.src})`,
        maskImage: `url(${logo.src})`,
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
    };
}
